// React
import ReactDOM from 'react-dom';

var React = require('react');
var createReactClass = require('create-react-class');

import { populate } from './../utilities/functions/populate.js';

import './archive-container.css';
import Post from './post.jsx';
import Posts from './posts.jsx';

import Loader from './loader.jsx';

import ReactPaginate from 'react-paginate';

var ArchiveContainer = createReactClass({

    getInitialState: function() {

        return({
            endpoint: '/wp-json/wp/v2/',
            slug : '',
            embed : '?_embed',
            count: '&per_page=12',
            page : '',
            data : [],
            preloadedData: [],
            totalItems : '',
            totalPages : '',
            load: false,
            category: ''
        });
    },

    // this is run once when the component mounts dom node
    componentDidMount: function(){

        var component = this;
        const componentContainer = document.getElementById('archiveContainer');
        
        component.setState({ load: true });

        let slug = componentContainer.dataset.slug ? componentContainer.dataset.slug : 'posts';
        let category = componentContainer.dataset.category ? '&categories=' + componentContainer.dataset.category : '';

        let page = componentContainer.dataset.page ? '&page=' + componentContainer.dataset.page : '';

        populate( component.state.endpoint + slug + component.state.embed + component.state.count + category + page  )

            .then(function( response ){

                component.setState({
                    slug : componentContainer.dataset.slug,
                    category : componentContainer.dataset.category,
                    page: componentContainer.dataset.page,
                    data : [],
                    totalItems : response.items,
                    totalPages : response.pages,
                    load: false
                });

            });

    },
    
    processPager: function(pageNumber){

        document.getElementById('wp-archive').style.display = 'none';
        var component = this;
        
        component.setState({ load: true });
                
        let page = pageNumber.selected != 0 ? '&page=' + (pageNumber.selected + 1) : '';        
        let slug = component.state.slug ? component.state.slug : 'posts';
        
        let filter = '';
        let taxonomy = '';
        let termid = '';
        var filterButtons = document.querySelectorAll('.archive--dropdown--button');
        for ( var y = 0; y < filterButtons.length; y++ ) {
            taxonomy = filterButtons[y].dataset.taxonomy;
            termid = filterButtons[y].dataset.selected;
            if (termid !== '')
                filter = filter + '&' + taxonomy + '=' + termid;
                
        }     
        
        populate( component.state.endpoint + slug + component.state.embed + component.state.count + filter + page  )

            .then(function( response ){

                component.setState({

                    page: (pageNumber.selected + 1),
                    data : response.data,
                    load: false

                });

            });
    },

    render: function() {

        var component = this;

        return (
            <div className="react--archive">
                <div className="row" id="hidden--nocontent">
                    <div className="col-lg-12 d-flex justify-content-center">
                        { component.state.category === '9' ?
                        <p>There are currently no Events scheduled</p>
                        :
                        <p>There is currently no content associated with your filter, please try another filter</p>
                        }
                    </div>
                </div>
                <Posts
                    data = { component.state.data }
                />
                <Loader
                    load = { component.state.load }
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={component.state.totalPages ? parseInt(component.state.totalPages) : 0}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={component.processPager}
                    containerClassName={(component.state.totalPages <= 1 ? 'pagination hidden' : 'pagination d-flex' )}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    forcePage={component.state.page ? (component.state.page-1) : 1}
                />
            </div>
        );
    }

});


var filterClear = document.getElementById('filterClear');
if ( filterClear ) {
    filterClear.addEventListener('click', function(e) {
        
        archive_filter.setState({ load: true });
        document.getElementById('hidden--nocontent').classList.remove('shown');
        
        this.setAttribute('disabled', '');
        
        var dropdownButtons = document.querySelectorAll('.dropdown--button');
        if ( dropdownButtons.length ) {
            for ( var x = 0; x < dropdownButtons.length; x++ ) {
                dropdownButtons[x].classList.remove('open');
            }
        }
        
        var filterButtons = document.querySelectorAll('.archive--dropdown--button');
        for ( var y = 0; y < filterButtons.length; y++ ) {
            filterButtons[y].dataset.selected = "";
            if (filterButtons[y].dataset.taxonomy === 'categories') {
                var buttonHtml = "Select type";
            }
            else if (filterButtons[y].dataset.taxonomy === 'focal_point') {
                var buttonHtml = "Select topic";
            }
            else {
                 var buttonHtml = "Select " + filterButtons[y].dataset.taxonomy.replace(/_/g, ' ');
            }
            filterButtons[y].firstChild.nextSibling.innerHTML  = buttonHtml;
        }

        const wpArchive = document.getElementById('wp-archive');
        wpArchive.classList.remove('hidden');
        
        const componentContainer = document.getElementById('archiveContainer');

        let slug = componentContainer.dataset.slug ? componentContainer.dataset.slug : 'posts';
        let category = componentContainer.dataset.category ? '&categories=' + componentContainer.dataset.category : '';

        populate( archive_filter.state.endpoint + slug + archive_filter.state.embed + archive_filter.state.count + category )

            .then(function( response ){ 

                archive_filter.setState({

                    page: 1,
                    taxonomy: '',
                    termid: '',
                    category: '',
                    data: response.data,
                    totalItems : response.items,
                    totalPages : response.pages,
                    load: false
                });

            });
    
    });
}

var filterSubmit = document.querySelectorAll('.select--option');
if ( filterSubmit.length ) {
    for ( var x = 0; x < filterSubmit.length; x++ ) {

        filterSubmit[x].addEventListener('click', function(e) {

            e.preventDefault();
            archive_filter.setState({ load: true });
            
            filterClear.removeAttribute('disabled');
           
            var taxonomy = e.target.dataset.taxonomy;
            var termid = e.target.dataset.value;
            var termname = e.target.dataset.name;

            document.getElementById('dropdown' + taxonomy + 'label').innerHTML = termname;
            
            document.getElementById('dropdown' + taxonomy).dataset.selected = termid;
            document.getElementById('dropdown' + taxonomy).classList.remove('open');
            
            //document.getElementById('archiveContainer').dataset.category = termid;

            //componentContainer.dataset

            const wpArchive = document.getElementById('wp-archive');
            document.getElementById('wp-archive').style.display = 'none';
            //filterClear.classList.remove('disabled');

            const componentContainer = document.getElementById('archiveContainer');

            let slug = componentContainer.dataset.slug ? componentContainer.dataset.slug : 'posts';

            let filter = '';
            var filterButtons = document.querySelectorAll('.archive--dropdown--button');
            for ( var y = 0; y < filterButtons.length; y++ ) {
                taxonomy = filterButtons[y].dataset.taxonomy;
                termid = filterButtons[y].dataset.selected;
                if (termid !== '')
                    filter = filter + '&' + taxonomy + '=' + termid;
                
                if (taxonomy === 'categories') {
                    archive_filter.setState({category: termid});
                }
            }
            
            let page = '&page=1';

        populate( archive_filter.state.endpoint + slug + '?_embed' + archive_filter.state.count + filter + page )

            .then(function( response ){

                var noContentMessage = document.getElementById('hidden--nocontent');
                noContentMessage.classList.remove('shown');
                if ( response.data.length === 0 ) {
                    noContentMessage.classList.add('shown');
                }

                // update components data state
                archive_filter.setState({
                    taxonomy: taxonomy,
                    termid: termid,
                    page: 1,
                    data: response.data,
                    totalItems : response.items,
                    totalPages : response.pages,
                    load: false
                });
            });

        });
    }
}

var dropdownButtons = document.querySelectorAll('.dropdown--button');
if ( dropdownButtons.length ) {
    for ( var x = 0; x < dropdownButtons.length; x++ ) {

        dropdownButtons[x].addEventListener('click', function(e) {
            if ( this.classList.contains('open') ) 
                this.classList.remove('open');
            else {
                this.classList.add('open');
            }
        });
    }
}

if ( document.getElementById('archiveContainer') ) {

    var archive_filter = ReactDOM.render(
        <ArchiveContainer/>,
        document.getElementById('archiveContainer')
    );

}